import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ApiClientErrorHandlersContext, } from './api-client-error-handlers-context';
export function ApiClientErrorHandlersProvider(_a) {
    var children = _a.children, onForbidden = _a.onForbidden;
    var value = useMemo(function () { return ({ onForbidden: onForbidden }); }, [onForbidden]);
    return (_jsx(ApiClientErrorHandlersContext.Provider, { value: value, children: children }));
}
